import { Origin, useAppAPIKeys } from "@/api";
import { APIKey, PartialApp } from "../../types/app.type";
import { apiKeysColumns } from "./APIKeysColumn";
import APIKeysTable from "./APIKeysTable";

interface Props {
  app: PartialApp;
}

function APIKeys({ app }: Props) {
  let origin;
  if (app.origin === "organization") origin = Origin.Organization;
  if (app.origin === "subscription") origin = Origin.Subscription;

  const { data } = useAppAPIKeys({
    appSlug: app.slug,
    subscriptionId: app.subscription?.id,
    origin
  });

  const apiKeysData: APIKey[] =
    data?.map((key) => ({
      id: key.id,
      name: key.name,
      value: key.secret,
      appSlug: app.slug,
      appSubscriptionId: app.subscription?.id,
      appOrigin: app.origin
    })) || [];

  if (apiKeysData.length < 1) return null;
  return <APIKeysTable columns={apiKeysColumns} data={apiKeysData} />;
}

export default APIKeys;
